import { isNil } from 'lodash';

import {
    FETCH_SENSOR_DATA,
    SENSOR_DATA_LOAD_BEGIN,
    SENSOR_DATA_LOAD_END,
    SENSOR_DATA_LOAD_ERROR
} from '../actions/actionTypes';

const initialState = { items: [], loading: false, error: null };

export default (state = initialState, action) => {
    let sensorData;

    switch (action.type) {
        case FETCH_SENSOR_DATA:
            sensorData = isNil(action.payload) ? [] : [...action.payload];

            return {
                ...state,
                items:   sensorData,
                loading: false
            };
        case SENSOR_DATA_LOAD_BEGIN:
            return {
                ...state,
                error:   initialState.error,
                loading: true
            };
        case SENSOR_DATA_LOAD_END:
            return {
                ...state,
                loading: false
            };
        case SENSOR_DATA_LOAD_ERROR:
            return {
                ...state,
                error: [...action.payload]
            };
        default:
            return state;
    }
};
